<template>
    <div id="app">
        <!-- 添加错误弹窗 -->
        <div v-if="showErrorDialog" class="dialog-overlay">
         <div class="dialog-content error-dialog">
            <h3>提示</h3>
            <div class="dialog-body">
                <p>该服务暂未提供</p>
            </div>
            <div class="dialog-footer">
                <button @click="confirmError" class="primary-btn">确认</button>
            </div>
        </div>
        </div>
      <h1>海量库库订单信息查询</h1>
      <div>
        <label>选择流程:
          <select v-model="selectedProcess">
            <option value="t_order_esim">esim</option>
            <option value="tf_b_preorder_broadband">宽带</option>
            <option value="TF_B_ORDER_OFFICIAL">宽带正式单</option>
            <option value="tf_b_glory_preorder">2I号卡</option>
            <option value="tf_b_glory_simple_preorder">2C号卡</option>
          </select>
        </label>
        <label>选择查询条件:
          <select v-model="selectedCondition">
            <option value="order_id">order_id</option>
            <option value="order_no">order_no</option>
          </select>
        </label>
        <label>输入查询值: <input v-model="queryValue" type="text"></label>
        <button @click="fetchOrder">查询订单</button>
      </div>
      <div v-if="order && Object.keys(order).length" class="order-container">
        <h2>订单信息</h2>
        <div class="order-info">
          <div v-for="(value, key) in order" :key="key" class="order-item">
            <div class="key">{{ key }}:</div>
            <div class="value">{{ value }}</div>
          </div>
        </div>
        <button @click="showRemarkDialog">保存订单</button>
      </div>
      <div>
        <h2>输入新订单进行比对</h2>
        <label>选择流程:
          <select v-model="newSelectedProcess">
            <option value="t_order_esim">esim</option>
            <option value="tf_b_preorder_broadband">宽带</option>
            <option value="TF_B_ORDER_OFFICIAL">宽带正式单</option>
            <option value="tf_b_glory_preorder">2I订单</option>
            <option value="tf_b_glory_simple_preorder">2C号卡</option>
          </select>
        </label>
        <label>选择查询条件:
          <select v-model="newSelectedCondition">
            <option value="order_id">order_id</option>
            <option value="order_no">order_no</option>
          </select>
        </label>
        <label>输入查询值: <input v-model="newQueryValue" type="text"></label>
        <button @click="compareOrders">比对订单</button>
      </div>
      <div v-if="comparisonResult && Object.keys(comparisonResult).length" class="order-container">
        <h2>比对结果</h2>
        <!-- 不一致的数据 -->
        <div v-if="differentResults.length > 0">
          <h3 class="comparison-subtitle">不一致的数据</h3>
          <div class="order-info">
            <div 
              v-for="item in differentResults" 
              :key="item.key" 
              class="order-item different"
            >
              <div class="key">{{ item.key }}:</div>
              <div class="value">
                <div>原始值: {{ (selectedSavedOrder || order)[item.key] }}</div>
                <div>新订单值: {{ newOrderData[item.key] }}</div>
                <div class="compare-result">不一致</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 一致的数据 -->
        <div v-if="sameResults.length > 0">
          <h3 class="comparison-subtitle">一致的数据</h3>
          <div class="order-info">
            <div 
              v-for="item in sameResults" 
              :key="item.key" 
              class="order-item"
            >
              <div class="key">{{ item.key }}:</div>
              <div class="value">
                <div>原始值: {{ (selectedSavedOrder || order)[item.key] }}</div>
                <div>新订单值: {{ newOrderData[item.key] }}</div>
                <div class="compare-result">一致</div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div v-if="savedOrders && savedOrders.length > 0" class="order-container">
        <div class="header-actions">
          <h2>已保存的历史订单信息</h2>
          <button class="clear-btn" @click="clearHistory">清空历史记录</button>
        </div>
        <div class="saved-orders">
          <div v-for="(savedOrder, index) in savedOrders" :key="index" class="saved-order">
            <div class="saved-order-header">
              <div class="header-left">
                <h3>历史订单 #{{index + 1}}</h3>
                <button 
                  class="toggle-btn" 
                  @click="toggleOrder(index)"
                >
                  {{ isOrderCollapsed(index) ? '展开' : '收起' }}
                </button>
                <button @click="useForComparison(savedOrder)">使用此订单进行比对</button>
                <button class="delete-btn" @click="deleteSavedOrder(index)">删除</button>
              </div>
              <div class="header-right">
                <span v-if="savedOrder.备注" class="order-remark">备注: {{ savedOrder.备注 }}</span>
                <span v-if="savedOrder.savedAt" class="order-remark">保存时间: {{ savedOrder.savedAt }}</span>
              </div>
            </div>
            <div v-show="!isOrderCollapsed(index)" class="order-content">
              <div class="order-info">
                <div v-for="(value, key) in filteredOrderData(savedOrder)" :key="key" class="order-item">
                  <div class="key">{{ key }}:</div>
                  <div class="value">{{ value }}</div>
                </div>
              </div>
              <!-- <div class="order-actions">
                <button @click="useForComparison(savedOrder)">使用此订单进行比对</button>
                <button class="delete-btn" @click="deleteSavedOrder(index)">删除</button>
              </div> -->
            </div>
          </div>
        </div>
      </div>
  
      <!-- 添加弹窗组件 -->
      <div v-if="showDialog" class="dialog-overlay">
        <div class="dialog-content">
          <h3>添加流程备注</h3>
          <div class="dialog-body">
            <input 
              v-model="orderRemark" 
              type="text" 
              placeholder="请填写流程信息"
              @keyup.enter="confirmSave"
            >
          </div>
          <div class="dialog-footer">
            <button @click="cancelSave">取消</button>
            <button @click="confirmSave" class="primary-btn">完成</button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PgDb',
    data() {
      return {
        // 错误弹窗
        showErrorDialog: true,
        selectedProcess: 't_order_esim',
        selectedCondition: 'order_id',
        queryValue: '',
        order: null,
        savedOrders: [],
        selectedSavedOrder: null,
        newSelectedCondition: 'order_id',
        newQueryValue: '',
        comparisonResult: null,
        newOrderData: null,
        orderRemark: '',
        showDialog: false, // 控制弹窗显示
        collapsedOrders: {}, // 保持这个对象
      };
    },
    async created() {
      await this.loadSavedOrders();
    },
    async mounted() {
      // 等待订单加载完成
      await this.loadSavedOrders();
      // 将所有订单设置为收起状态
      this.savedOrders.forEach((_, index) => {
        this.$set(this.collapsedOrders, index, true);
      });
    },
    computed: {
      newSelectedProcess: {
        get() {
          return this.selectedProcess;
        },
        set(value) {
          this.selectedProcess = value;
        }
      },
      differentResults() {
        if (!this.comparisonResult) return [];
        return Object.entries(this.comparisonResult)
          .filter(([, isSame]) => !isSame)
          .map(([key]) => ({ key }));
      },
      sameResults() {
        if (!this.comparisonResult) return [];
        return Object.entries(this.comparisonResult)
          .filter(([, isSame]) => isSame)
          .map(([key]) => ({ key }));
      }
    },
    methods: {
        // 错误弹窗
        confirmError() {
            this.showErrorDialog = false;
            this.$router.push('/'); // 点击确认后返回首页
        },
      async fetchOrder() {
        try {
          const response = await fetch(
            `http://localhost:8081/get_pgorder?process=${this.selectedProcess}&condition=${this.selectedCondition}&value=${this.queryValue}`
          );
          const data = await response.json();
          console.log('API Response:', data);
          
          if (response.ok) {
            // 确保 data 不为 null
            this.order = data || {};
            console.log('Set order data:', this.order);
          } else {
            this.order = null;
            alert(data.message || '查询失败');
          }
        } catch (error) {
          this.order = null;
          console.error('查询订单时出错:', error);
        }
      },
      async loadSavedOrders() {
        try {
          const response = await fetch('http://localhost:8081/load_pgorders');
          if (response.ok) {
            this.savedOrders = await response.json();
          } else {
            console.error('加载历史订单失败');
          }
        } catch (error) {
          console.error('加载历史订单失败:', error);
        }
      },
      async saveOrder() {
        if (this.order) {
          try {
            const orderToSave = {
              ...this.order,
              savedAt: new Date().toLocaleString(),
              备注: this.orderRemark.trim()
            };
            
            const response = await fetch('http://localhost:8081/save_pgorder', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(orderToSave)
            });
  
            if (response.ok) {
              await this.loadSavedOrders();
              this.orderRemark = '';
              alert('订单信息已保存');
            } else {
              alert('保存订单失败');
            }
          } catch (error) {
            console.error('保存订单时出错:', error);
            alert('保存订单失败');
          }
        }
      },
      async deleteSavedOrder(index) {
        if (confirm('确定要删除这条历史订单吗？')) {
          try {
            const response = await fetch(`http://localhost:8081/delete_pgorder/${index}`, {
              method: 'DELETE'
            });
  
            if (response.ok) {
              await this.loadSavedOrders();
              if (this.selectedSavedOrder === this.savedOrders[index]) {
                this.selectedSavedOrder = null;
              }
            } else {
              alert('删除订单失败');
            }
          } catch (error) {
            console.error('删除订单时出错:', error);
            alert('删除订单失败');
          }
        }
      },
      useForComparison(savedOrder) {
        this.selectedSavedOrder = savedOrder;
        alert('已选择此订单作为比对基准');
      },
      async compareOrders() {
        try {
          const response = await fetch(
            `http://localhost:8081/get_pgorder?process=${this.newSelectedProcess}&condition=${this.newSelectedCondition}&value=${this.newQueryValue}`
          );
          const newOrder = await response.json();
          if (response.ok) {
            this.comparisonResult = {};
            const baseOrder = this.selectedSavedOrder || this.order;
            if (!baseOrder) {
              alert('请先查询要比对的订单或选择一个历史订单');
              return;
            }
            this.newOrderData = newOrder;
            for (const key in baseOrder) {
              if (Object.prototype.hasOwnProperty.call(baseOrder, key) && 
                  Object.prototype.hasOwnProperty.call(newOrder, key)) {
                this.comparisonResult[key] = baseOrder[key] === newOrder[key];
              }
            }
          } else {
            alert(newOrder.message);
          }
        } catch (error) {
          console.error('比对订单时出错:', error);
        }
      },
      async clearHistory() {
        if (confirm('确定要清空所有历史记录吗？')) {
          try {
            const response = await fetch('http://localhost:8081/clear_pgorders', {
              method: 'DELETE'
            });
  
            if (response.ok) {
              this.savedOrders = [];
              this.selectedSavedOrder = null;
            } else {
              alert('清空历史记录失败');
            }
          } catch (error) {
            console.error('清空历史记录时出错:', error);
            alert('清空历史记录失败');
          }
        }
      },
      // 显示备注弹窗
      showRemarkDialog() {
        this.showDialog = true;
        this.orderRemark = ''; // 清空之前的备注
      },
  
      // 取消保存
      cancelSave() {
        this.showDialog = false;
        this.orderRemark = '';
      },
  
      // 确认保存
      async confirmSave() {
        if (!this.orderRemark.trim()) {
          alert('请填写流程信息');
          return;
        }
        await this.saveOrder();
        this.showDialog = false;
      },
  
      // 修改过滤订单数据的方法
      filteredOrderData(order) {
        // eslint-disable-next-line no-unused-vars
        const { 备注: _备注, ...filteredOrder } = { ...order };
        return filteredOrder;
      },
  
      // 修改切换方法
      toggleOrder(index) {
        this.$set(this.collapsedOrders, index, !this.collapsedOrders[index]);
      },
  
      // 修改检查方法
      isOrderCollapsed(index) {
        // 如果状态未设置，默认返回 true（收起状态）
        return this.collapsedOrders[index] !== false;
      },
    }
  };
  </script>
  
  <style scoped>
  .order-container {
    margin: 20px 0;
    padding: 15px;
    border: 1px solid #eee;
    border-radius: 8px;
  }
  
  .order-info {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    padding: 10px;
  }
  
  .order-item {
    background-color: #f8f9fa;
    padding: 8px 12px;
    border-radius: 6px;
    min-width: 250px;
    max-width: calc(33% - 12px);
    display: flex;
    align-items: flex-start;
  }
  
  .key {
    font-weight: bold;
    margin-right: 8px;
    color: #666;
  }
  
  .value {
    word-break: break-all;
    flex: 1;
  }
  
  .compare-result {
    margin-top: 4px;
    font-weight: bold;
  }
  
  .different .compare-result {
    color: #ff4444;
  }
  
  button {
    margin: 10px 0;
    padding: 8px 16px;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  button:hover {
    background-color: #45a049;
  }
  
  select, input {
    margin: 10 -10px;
    padding: 6px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  
  label {
    margin-right: 20px;
  }
  
  h1, h2 {
    font-size: 20px;
    color: #333;
  }
  
  .saved-orders {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  .saved-order {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 15px;
    background-color: #fff;
    margin-bottom: 10px;
  }
  
  .saved-order h3 {
    margin: 0 0 10px 0;
    font-size: 16px;
    color: #666;
  }
  
  .order-actions {
    margin-top: 10px;
    display: flex;
    gap: 10px;
  }
  
  .delete-btn {
    background-color: #ff4444;
  }
  
  .delete-btn:hover {
    background-color: #ee3333;
  }
  
  .header-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }
  
  .clear-btn {
    background-color: #666;
    font-size: 14px;
    padding: 6px 12px;
  }
  
  .clear-btn:hover {
    background-color: #555;
  }
  
  .comparison-subtitle {
    font-size: 16px;
    color: #666;
    margin: 15px 0 10px 0;
    padding-left: 10px;
    border-left: 3px solid #4CAF50;
  }
  
  .different {
    background-color: #fff0f0;
  }
  
  .different .key,
  .different .value {
    color: #ff4444;
  }
  
  .different .compare-result {
    color: #ff4444;
    font-weight: bold;
  }
  
  .save-section {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-top: 15px;
  }
  
  .remark-input {
    flex: 1;
  }
  
  .remark-input input {
    width: 300px;
  }
  
  .saved-order-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    padding: 8px;
    background-color: #f8f9fa;
    border-radius: 6px;
  }
  
  .order-remark {
    color:#ee3333;
    font-size: 14px;
    background-color: #f0f0f0;
    padding: 4px 8px;
    border-radius: 4px;
  }
  
  .saved-order h3 {
    margin: 0;
  }
  
  .dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .dialog-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    min-width: 400px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
  
  .dialog-content h3 {
    margin: 0 0 20px 0;
    color: #333;
    font-size: 18px;
  }
  
  .dialog-body {
    margin-bottom: 20px;
  }
  
  .dialog-body input {
    width: 80%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
  }
  
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
  
  .dialog-footer button {
    padding: 6px 16px;
    margin: 0;
  }
  
  .primary-btn {
    background-color: #4CAF50;
  }
  
  .dialog-footer button:not(.primary-btn) {
    background-color: #999;
  }
  
  .dialog-footer button:not(.primary-btn):hover {
    background-color: #888;
  }
  
  .header-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .header-right {
    display: flex;
    gap: 10px;
  }
  
  .toggle-btn {
    padding: 4px 8px;
    font-size: 12px;
    background-color: #f0f0f0;
    color: #666;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .toggle-btn:hover {
    background-color: #e0e0e0;
  }
  
  .order-content {
    transition: all 0.3s ease;
  }
  .error-dialog {
  text-align: center;
}
/* 错误弹窗 */
.error-dialog .dialog-body {
  margin: 20px 0;
}

.error-dialog p {
  color: #ff4444;
  font-size: 18px;
  margin: 0;
}

.error-dialog .primary-btn {
  background-color: #3498db;
  min-width: 100px;
}

.error-dialog .primary-btn:hover {
  background-color: #2980b9;
}
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  min-width: 300px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.dialog-content h3 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 18px;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.dialog-footer button {
  padding: 8px 24px;
  margin: 0;
  font-size: 16px;
}
  </style>